import { App, Plugin } from 'vue';
import { SEOManager } from './SEOManager';
import { SEOConfig } from './types';

// Global SEO manager instance
let globalSEOManager: SEOManager | null = null;

export const SEOPlugin: Plugin = {
    install(app: App, options: SEOConfig = {}) {
        // Get store from options (passed from main.ts) or app context as fallback
        const store = options.store || app.config.globalProperties.$store;

        // Create global SEO manager instance with store
        globalSEOManager = new SEOManager(options, store);

        // Provide SEO manager to all components
        app.provide('seoManager', globalSEOManager);

        // Add global properties
        app.config.globalProperties.$seo = globalSEOManager;

        // Clean up on app unmount
        const originalUnmount = app.unmount;
        app.unmount = function () {
            if (globalSEOManager) {
                globalSEOManager.cleanup();
                globalSEOManager = null;
            }
            originalUnmount.call(this);
        };
    },
};

// Export function to get the global SEO manager
export function getSEOManager(): SEOManager | null {
    return globalSEOManager;
}

// Export the manager class and types
export { SEOManager } from './SEOManager';
export * from './types';
